export default __webpack_public_path__ + "static/media/img7.e6739e27.jpeg";